import getClient from './getClient';

export type ApiHealthCheck = {
  data: {
    mail_and_calendar_provider: { valid: boolean };
    salesforce: { valid: boolean };
    groove_license: { valid: boolean };
    sfdc_api_access: { valid: boolean };
    managed_package: { valid: boolean };
    sfdc_meta: { valid: boolean };
  };
};

export const healthCheck = (): Promise<ApiHealthCheck> => {
  return getClient().get('health/check').json();
};
